import { ICreateItemProcessoFatorUseCase } from "../../../presentation/useCases/create/create_item_processo_fator_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

export class CreateItemProcessoFatorUseCase implements ICreateItemProcessoFatorUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async createItemProcessoFator( IdItemProcesso: number | null, FatorRisco: string | null, IternoExterno: string | null, Consequencia: string | null, Oportunidade: string | null, Acao: string | null, Acompanhamento: string | null, Ocorrencia: number | null, Impacto: number | null, RiscoOportunidade: number | null
  ): Promise<void> {
    await this.repository.createItemProcessoFator(IdItemProcesso, FatorRisco, IternoExterno, Consequencia, Oportunidade, Acao, Acompanhamento, Ocorrencia, Impacto, RiscoOportunidade);
  }
}